import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import Measure from 'react-measure'

import { Animation, Button, ListTile, Tooltip } from 'components'
import { ToggleButton, ShortcutsModal, FeedbackModal, UpdatesModal } from 'features'
import { AnimateSharedLayout, AnimatePresence, motion } from 'framer-motion'
import { FaQuestion, FaTimes, FaAngleUp, FaKeyboard, FaThumbsUp, FaRocket } from 'react-icons/fa'

import * as actionCreators from 'store/actions';
import classes from './Support.module.css'

const Container = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    transform: translate(-1.5rem, -1rem);
    /* margin: 1rem; */
    z-index: 1299;
    /* display: flex;
    justify-content: flex-end; */

    display: grid;
    grid-template-columns: auto auto;
    align-items: end;
`

const ButtonContainer = styled.div`
    background-color: var(--secondary-color);
    box-shadow: var(--box-shadow);
    color: var(--primary-accent-color);
    font-size: 1rem;
    padding: 0.5rem;

    position: relative;
    bottom: 0;
    right: 0;
    
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    :hover{
        filter: brightness(var(--brightness));
    }
`

const ModalContainer = styled.div`
    background-color: var(--secondary-color);
    box-shadow: var(--box-shadow);
    border-radius: 5px;
    padding: 1rem;
    width: 20rem;
    height: 100%;
    margin-right: 0.5rem;
    /* min-height: 20rem; */

    display: flex;
    flex-direction: column;
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    text-transform: uppercase;
    padding: 0 0 0 0.25rem;
    color: var(--secondary-accent-color);
`

const Wrapper = styled.div`
    display: grid;
    grid-template-rows: auto 1fr;
    overflow: hidden;
`

const Content = styled.div`
    /* border-top: 1px solid var(--primary-accent-color); */
    border-bottom: 1px solid var(--primary-accent-color);
`


const Support = props => {
    const {} = props;
    const dispatch = useDispatch()
    const modalID = useSelector(state => state.content.modalID)
    const [tab, setTab] = React.useState('SHORTCUTS')

    const options = {
        SHORTCUTS: {
            title: 'Shortcuts',
            value: 'SHORTCUTS',
            icon: <FaKeyboard/>,
            content: <ShortcutsModal inline styles={{backgroundColor: 'var(--secondary-color)', secondaryColor: 'var(--primary-color)', padding: '0.25rem 0.5rem 0.5rem 0.5rem'}}/>
        },
        FEEDBACK: {
            title: 'Feedback',
            value: 'FEEDBACK',
            icon: <FaThumbsUp/>,
            content: <FeedbackModal inline styles={{ secondaryColor: 'var(--primary-color)' }}/>
        }, 
        // UPDATES: {
        //     title: 'Updates',
        //     value: 'UPDATES',
        //     icon: <FaRocket/>,
        //     onSelect: () => dispatch(actionCreators.setModal(<UpdatesModal/>, 'updatesModal'))
        // }  
    }

    React.useEffect(() => { // To ensure event listener updates
        const onKeyPress = window.addEventListener('keydown', keyHandler, true)
        return () => {window.removeEventListener('keydown', keyHandler, true)}
    }, [])

    const keyHandler = (event) => {
        switch(event.keyCode){
            case 40: // Down
                break
            case 38: // Up
                break
            case 13: // Enter
                break
            case 27: // Esc
                modalID === 'supportModal' && onOpen()
                break
        }
    }

    const onOpen = () => {
        dispatch(actionCreators.setModal(null,modalID !== 'supportModal' ? 'supportModal' : null))
    }

    const onTab = (value) => {
        setTab(tab === value ? null : value)
    }

    return (
        <Container>            
            <AnimatePresence initial={false}>
                {modalID === 'supportModal' && <motion.div key='content' size='100%' position="relative" background='transparent'
                    initial="collapsed" animate="open" exit="collapsed"
                    transition={{ duration: 0.3 }}
                    variants={{
                        // open: { scale: 1, transformOrigin: '95% 95%'},
                        // collapsed: { scale: 0,  transformOrigin: '95% 95%'}
                        open: { height: 'auto', opacity: 1},
                        collapsed: { height: 0, opacity: 0, }
                    }}>
                    <ModalContainer>
                        <Header>
                            <Title>Help and support</Title>
                            <Button icon={<FaTimes/>} onSelect={onOpen}
                                styles={{ margin: 0, color: 'var(--primary-accent-color)', backgroundColor: 'var(--secondary-color)', boxShadowColor: 'transparent', padding: '0.4rem', fontSize: '0.8rem' }}/>
                        </Header>

                        {Object.values(options).map(option => (
                            <Wrapper key={option['value']}>
                                <ListTile text={option['title']} key={option['value']}
                                    onSelect={() => option['onSelect'] ? option['onSelect']() : onTab(option['value'])}
                                    icon={option['icon']}
                                    styles={{ backgroundColor: 'var(--secondary-color)' }}
                                    trailingPersist={option['onSelect'] ? false : true}
                                    trailingIcon={
                                        !option['onSelect'] && <ToggleButton open={tab === option['value']} 
                                            styles={{color: 'var(--secondary-accent-color)', padding: 0, margin: 0, fontSize: '0.8rem'}} 
                                            icon={<FaAngleUp/>} end={180} alignment='center'/>
                                    }/>
                                <AnimatePresence initial={false}>
                                    {tab === option['value'] && option['content'] && <Animation animation='expand'><Content>{option['content']}</Content></Animation>}
                                </AnimatePresence>
                            </Wrapper>
                        ))}
                    </ModalContainer>    
                </motion.div>}
            </AnimatePresence>


            <Tooltip arrow placement='left' title={<div className={classes.Tooltip}><div>Support</div><div className={classes.Code}>Shift+?</div></div>}>
                <ButtonContainer onClick={onOpen}><FaQuestion/></ButtonContainer>
            </Tooltip>
        </Container>
    )
}

export default Support;